import React from 'react';
import { Folder as FolderOutlinedIcon } from 'lucide-react';
import { SidebarMenuItem, SidebarMenuButton } from 'src/shared/components/ui/sidebar';
import { useAppSelector } from 'src/store';
import { getAppRoutesAvailability } from 'src/routes/state/routesSelector';
import { Link, useLocation } from 'react-router-dom';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { projectRouteSettings } from 'src/app/projects/Projects';

const MySitesMenuItem = () => {
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const navigate = useAppNavigation();
    const { pathname } = useLocation();

    if (!appRoutesAvailability.projects) {
        return null;
    }

    return (
        <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip={projectRouteSettings.projects.name} isActive={pathname === '/projects'}>
                <Link to={navigate.paths.projects()} data-testid='projects-menu-button'>
                    <FolderOutlinedIcon />
                    <span>{projectRouteSettings.projects.name}</span>
                </Link>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
};

export default MySitesMenuItem;
